import { render, staticRenderFns } from "./CurrencySelect.vue?vue&type=template&id=6b28dfc6"
import script from "./CurrencySelect.vue?vue&type=script&lang=ts"
export * from "./CurrencySelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b28dfc6')) {
      api.createRecord('6b28dfc6', component.options)
    } else {
      api.reload('6b28dfc6', component.options)
    }
    module.hot.accept("./CurrencySelect.vue?vue&type=template&id=6b28dfc6", function () {
      api.rerender('6b28dfc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CurrencySelect.vue"
export default component.exports